<template>
  <div id="el-case-statis">
    <div class="tit-rit">箱柜统计</div>
    <div class="el-data-statis">
      <div class="el-block">
        <el-date-picker
          v-model="monthStatis"
          type="month"
          placeholder="按月份统计"
          value-format="yyyy-MM"
          @blur="getCasestatis()"
        >
        </el-date-picker>
      </div>
      <div class="el-block">
        <el-button type="primary" @click="sendMailcase()">统计推送</el-button>
      </div>
    </div>
    <div class="el-case-sta-box">
      <el-table
        :data="caseStatis"
        stripe
        border
        style="width: 100%"
        :header-cell-style="{
          color: '#696969',
          'background-color': '#DBE6FF',
          'border-bottom': '1px solid #fff',
          'font-size': '16px',
          'text-align': 'center',
        }"
        :cell-style="{
          'text-align': 'center',
        }"
      >
        <el-table-column prop="case_no" label="箱号"> </el-table-column>
        <el-table-column prop="startStation" label="始发站"> </el-table-column>
        <el-table-column prop="endStation" label="目的站"> </el-table-column>
        <el-table-column prop="diffDays" label="相差天数"> </el-table-column>
        <el-table-column prop="ATD" label="ATD"> </el-table-column>
        <el-table-column prop="ATA" label="ATA"> </el-table-column>
      </el-table>
      <div class="el-pagion-statis">
        <el-pagination
          background
          :page-size="pagesize"
          layout="prev, pager, next"
          :total="total"
          @current-change="getCasestatis"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Casestatis",
  data() {
    return {
      monthStatis: "",
      total: null,
      pagesize: 10, //每页显示条数
      currpage: 1, //页码
      caseStatis: [
        {
          case_no: "--",
          startStation: "--",
          endStation: "--",
          diffDays: "--",
          ATD: "--",
          ATA: "--",
        },
      ],
    };
  },
  mounted() {
    this.getCasestatis();
  },
  methods: {
    //搜索获取月度箱柜数据
    getCasestatis(cpage) {
      this.openLoading();
      let tokens = localStorage.getItem("token");
      this.currpage = cpage;
      this.$axios
        .post("CaseNo/caseArrive", {
          token: tokens,
          month: this.monthStatis,
          curPage: this.currpage,
          pageNum: this.pagesize,
        })
        .then((res) => {
          this.closeLoading(this.openLoading());
          this.caseStatis = res.data.data;
          this.total = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //推送箱柜数据
    sendMailcase() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("SendMail/pushCaseMonth", {
          token: tokens,
          month: this.monthStatis,
        })
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: "success",
            offset: 200,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //延时loading
    openLoading() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中,请稍后......",
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,0.1)",
      });
      return loading;
    },
    closeLoading(loading) {
      loading.close();
    },
  },
};
</script>
<style scoped>
@import "./coms/user.css";
</style>


// WEBPACK FOOTER //
// src/components/user/case_statis.vue